import { useState } from 'react';
import { Button, toast } from '@components';
import { BUTTON_TYPES, TUpdateCPIIncreaseRequest } from '@types';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import { useRecoilState } from 'recoil';
import { RateCard as RateCardState } from '@state';
import { useScheduleCPIIncrease } from '@api/RateCards/cpiIncreaseApis.ts';
import { CPIIncreaseScheduleDialog } from '@components/PAGE_LAYOUTS/RC_RateCard/CPIIncreaseScheduleDialog.tsx';
import { useRefetchLane } from '@hooks';

export const CPIIncreaseScheduleButton = ({ isDisabled }: {isDisabled: boolean}) => {
	const [open, setOpen] = useState(false);
	const [rateCard, setRateCard] = useRecoilState(RateCardState);
	const { callScheduleCPIIncrease, isLoading } = useScheduleCPIIncrease();
	const { refetchLane } = useRefetchLane();

	if (!rateCard?.external_id) {
		return null;
	}

	const onSubmit = async (request: TUpdateCPIIncreaseRequest) => {
		const laneExternalId = rateCard?.external_id;
		if (!laneExternalId) {
			return;
		}
		await callScheduleCPIIncrease({
			payload: {
				lane_external_id: laneExternalId,
				scheduled_at: request.scheduled_at,
				cpi_percentage: request.cpi_percentage,
			}
		}).then((response) => {
			toast.success('CPI increase scheduled successfully.');
			const cpiIncrease = response.data?.data;
			if (cpiIncrease?.processed_at) {
				// An increase with today's date applies immediately. Refetch lane to show updated rates.
				refetchLane(laneExternalId);
			} else {
				setRateCard((prev) => prev ? { ...prev, latest_cpi_increase: cpiIncrease } : prev);
			}
			setOpen(false);
		}).catch((err: Error) => {
			const errorData = (err.cause as any)?.response?.data;
			toast.error(errorData?.message || err.message || 'An error occurred while scheduling the CPI increase.');
		});
	};

	return (
		<>
			<Button
				text={'Schedule CPI Increase'}
				type={BUTTON_TYPES.TERTIARY}
				Icon={PercentOutlinedIcon}
				onClick={() => setOpen(true)}
				disabled={isDisabled}
			/>
			<CPIIncreaseScheduleDialog
				type={'create'}
				isOpen={open}
				isLoading={isLoading}
				onSubmit={onSubmit}
				onClose={() => setOpen(false)}
			/>
		</>
	);
};
